import {referralEmailSend} from "../Service/auth.service";
import { BrowserProvider } from "ethers";
import { Contract } from "ethers";
import presale from "../blockchain/Presale.json";
const ethers = require('ethers')
const ERC20_ABI = [
    "function balanceOf(address owner) view returns (uint256)",
    "function decimals() view returns (uint8)",
];

export default async function sendReferralMail(path, email, percentage, couponCode) {

    const protocol = window.location.protocol;
    const currentDomain = window.location.hostname;
    const port = 3000;

    let referUrl;

    if (protocol === 'http:') {
        referUrl = `${protocol}//${currentDomain}:${port}/${path}/?ref=${couponCode}`;
    } else {
        referUrl = `${protocol}//${currentDomain}/${path}/?ref=${couponCode}`;
    }

    await referralEmailSend({
        email : email,
        percentage : percentage,
        url : referUrl
    });
}
export async function getIpAddress() {
    try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        return data.ip; // Returning the resolved IP address
    } catch (error) {
        console.error('Error fetching the IP address:', error);
        throw error; // Re-throw the error if needed
    }
}
export async function getMetaMaskDetails(walletProvider , selectedCurrency){
    let ethersProvider = new BrowserProvider(walletProvider)
    async function getWalletLocalToken(address ){
        const balance = await ethersProvider.getBalance(address);
        // return  (balance / (10n ** 18n)).toString();
        const balanceInEther = Number(balance) / Number(10n ** 18n); // Convert balance and divisor to Numbers
        return (balanceInEther.toFixed(8));
    }
    // async function get(address) {
    //     let bnbContract = new Contract(process.env.REACT_APP_MAINNET_BNB_CONTRACT_ADDRESS, ERC20_ABI, ethersProvider);
    
    //     const bnbBalance = await bnbContract.balanceOf(address);
    //     const bnbDecimals = await bnbContract.decimals();
    
    //     return (bnbBalance / (10n ** bnbDecimals)).toString();
    // }
    
    const signer = await ethersProvider.getSigner();
    const address = (await signer).getAddress();
    
    const network = await ethersProvider.getNetwork();
    let result = {
        network: network.name,
    } 
    async function fetchDetails(){
        if(typeof window.ethereum !== "undefined"){

            const getNetworkDetail = new BrowserProvider(walletProvider);
            const getNetworkName = await getNetworkDetail.getNetwork();

           console.log("Network Name ",getNetworkName.name);

            let etherium , usdt  , bnb;
            if(getNetworkName.name === "mainnet"){
                if (selectedCurrency === "ETH"){
                    etherium = await getWalletLocalToken(address)
                    result["eth"] = Number(etherium)
                }
                else if ( selectedCurrency === "BNB" ){
                    bnb = await getWalletLocalToken(address) //add BNB
                    result["bnb"] = Number(bnb)
                }
            }
            else if (getNetworkName.name === "bnbt"){
                bnb = await getWalletLocalToken(address);
                result["bnb"] = bnb;
            }
            else if( getNetworkName.name === "sepolia" ){
                if ( selectedCurrency === "BNB" ){
                    bnb = await getWalletLocalToken(address) //add BNB
                    result["bnb"] = Number(bnb)
                }
                else if (selectedCurrency === "ETH"){
                    etherium = await getWalletLocalToken(address)
                    result["eth"] = Number(etherium)
                }
            }
            else if( getNetworkName.name === "bnb" ){
                if ( selectedCurrency === "BNB" ){
                    bnb = await getWalletLocalToken(address) //add BNB
                    result["bnb"] = Number(bnb)
                }
            }
            else if (getNetworkName.name === "unknown"){
                if (selectedCurrency === "ETH"){
                    etherium = await getWalletLocalToken(address)
                    result["eth"] = Number(etherium)
                }
                else if ( selectedCurrency === "BNB" ){
                    bnb = await getWalletLocalToken(address) //add BNB
                    result["bnb"] = Number(bnb)
                }
            }
        }
    }
    await fetchDetails()
    if (window.ethereum) {
        window.ethereum.on('chainChanged', async (chainId) => {
            try {
                // Update ethersProvider when network changes
                ethersProvider = new BrowserProvider(walletProvider);
                console.log(chainId);
                // Fetch details again after the network change
                await fetchDetails();
            } catch (error) {
                console.error('Error on network change:', error);
            }
        });
    
        window.ethereum.on('accountsChanged', async (accounts) => {
            // Optional: Re fetch details if the account changes (e.g., user switches accounts in MetaMask)
            if (accounts.length > 0) {
                await fetchDetails();
            }
        })
        
    }
    
    // console.log(result)
    return result 

}

export const addTokenToMetaMask = async () => {
    const tokenAddress = presale.presaleToken.contractAddress; // Token contract address
    const tokenSymbol = process.env.REACT_TOKEN_SYMBOL; // Token symbol
    const tokenDecimals = 18; // Token decimals
    const tokenABI = presale.presaleToken.abi

    if (!window.ethereum) {
        console.log('MetaMask is not installed. Please install MetaMask to use this feature.');
        return false;
    }

    // Initialize ethers provider and contract
    const provider = new BrowserProvider(window.ethereum);
    const signer = await provider.getSigner();
    const walletAddress = await signer.getAddress();
    const tokenContract = new ethers.Contract(tokenAddress, tokenABI, provider);

    try {
        // Check if the wallet already has the token (balance will be zero or greater)
        const balance = await tokenContract.balanceOf(walletAddress);
        const tokenContractDecimals = await tokenContract.decimals();
        const tokenBalanceAmount = Number((balance / (10n ** tokenContractDecimals)).toString());

        if (tokenBalanceAmount > 0) {
            console.log("$HOME token already added to MetaMask.");
            return false;
        }
    } catch (error) {
        console.error('Error checking token balance:', error);
        return false;
    }

    // If balance check fails or returns no result, attempt to add the token
    try {
        const result = await window.ethereum.request({
            method: 'wallet_watchAsset',
            params: {
                type: 'ERC20',
                options: {
                    address: tokenAddress,
                    symbol: tokenSymbol,
                    decimals: tokenDecimals,
                },
            },
        });

        if (result) {
            console.log(`$HOME token added to MetaMask!`);
        } else {
            console.log(`$HOME token addition to MetaMask was declined by the user.`);
        }
    } catch (error) {
        console.error('Failed to add token:', error);
        return false;
    }

    return true;
};
export function getReferralCodeFromCookies(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

export function getJsonCookies(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        const cookieValue = parts.pop().split(';').shift();
        try {
            const parsedValue = JSON.parse(cookieValue);
            return parsedValue;
        } catch (e) {
            console.log("PARSING FAILEd" , e)
        }
    }
}

export function isMobileDevice() {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}